import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { RaciService } from '../../../raci/services/raci.service';
import { RaciNavigationService } from '../../../../navigation/raci-navigation.service';
import { Subscription } from 'rxjs';
import { AppStorageService } from '../../../../services/app-storage.service';

/**
 * Handles the raci approval dialog
 */
@Component({
  selector: 'raci-approval-dialog',
  templateUrl: './raci-approval-dialog.component.html',
  styleUrls: ['./raci-approval-dialog.component.css']
})
export class RaciApprovalDialogComponent implements OnInit, OnDestroy {

  /**
  * Current user
  */
  public currentUser: any;

  /**
   * Regional groups data
   */
  regionalGroups: any;

  /**
   * Business units data
   */
  businessUnits: any;

  /**
  * Is a BU selected
  */
  selectedRegionalGroup = 0;

  /**
  * Selected BU
  */
  selectedBU = 0;

  /**
  * Users list
  */
  users: any[];

  /**
  * Approval comment
  */
  approvalComment: any;

  /**
   * Flag for approve button
   */
  isDisabled = true;

  /**
   * Indicates whether the task is general task
   */
  @Input() isGeneralTask: boolean;

  /**
   * Indicates whether the dialog can be closed
   */
  @Input() canClose: boolean;

  /**
   * Selected general task
   */
  @Input() set selectedGeneralTask(value: any) {
    if (value?.projectId != null) {
      this.selectedRegionalGroup = value.regionId;
      this.selectedBU = value.ownerBuId;
      this.validate();
    }
  }

  /**
   * On approve emitter
   */
  @Output() onApprove = new EventEmitter<any>();

  /**
   * The subscriptions
   */
  private _subscriptions: Array<Subscription> = [];

  /**
   * Constructor
   * @param _raciService
   * @param _raciNavigationService
   * @param appStorage
   */
  constructor(private _raciService: RaciService, private _raciNavigationService: RaciNavigationService, private appStorage: AppStorageService) { }

  /**
   * OnInit
   */
  ngOnInit(): void {
    this.getRegionalGroups();
    this.getBusinessUnits();
    this.currentUser = this.appStorage.getCurrentUserDetails();
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }

  /**
   * Load regional groups from the raci service
   */
  getRegionalGroups(): void {
    this._subscriptions.push(this._raciService.cfApprovalProjectRegions().subscribe(data => {
      if (data) {
        this.regionalGroups = data;
      }
    }));
  }

  /**
   * Load BUs from the raci service
   */
  getBusinessUnits(): void {
    this._subscriptions.push(this._raciService.loadBusinessUnits().subscribe(data => {
      if (data) {
        this.businessUnits = data;
      }
    }));
  }

  /**
   * Method for handling the "approve" button click
   */
  approve(): void {
    const approveObject: { comment: string, type: string, businessUnit: number, regionalGroup: number } = { comment: this.approvalComment, type: 'approve', businessUnit: this.selectedBU, regionalGroup: this.selectedRegionalGroup };
    this.onApprove.emit(approveObject);
    this._raciNavigationService.showApprovalMatrixDialog(false);
    this._raciNavigationService.isApprovalClicked(false);
  }

  /**
   * Method for handling the "reject" button click
   */
  reject(): void {
    const approveObject: { comment: string, group: any, type: string } = { comment: this.approvalComment, group: this.selectedRegionalGroup, type: 'reject' };
    this.onApprove.emit(approveObject);
    this._raciNavigationService.showApprovalMatrixDialog(false);
    this._raciNavigationService.isApprovalClicked(false);
  }

  /**
   * Method for closing the dialog
   */
  closeApprovalMatrix(): void {
    this._raciNavigationService.showApprovalMatrixDialog(false);
    this._raciNavigationService.isApprovalClicked(false);
  }

  /**
   * Method for validating if business unit is selected
   */
  validate() {
    this.isDisabled = this.selectedBU <= 0;
  }

}
